import CryptoJS from "crypto-js";

export interface User {
  userId: string;
  name: string;
  cypherKey: Array<number>;
}

export interface UserRecord {
  userId: string;
  data: string;
}

export const encryptUser = async (data: User, password: string) => {
  const encodedPlainText = JSON.stringify({
    ...data,
    cypherKey: [...data.cypherKey],
  });
  const encryptedData = CryptoJS.AES.encrypt(encodedPlainText, password);

  const userRecord: UserRecord = {
    userId: data.userId,
    data: encryptedData.toString(),
  };
  return userRecord;
};

export const decryptUserRecord = async (data: UserRecord, password: string) => {
  const decodedData = CryptoJS.AES.decrypt(data.data, password);
  return JSON.parse(decodedData.toString(CryptoJS.enc.Utf8)) as User;
};

export const createUser = async (data: { userId: string; name: string }) => {
  //create a cypher key
  const cypherKey = crypto.getRandomValues(new Uint8Array(32));
  const user: User = {
    userId: data.userId,
    cypherKey: [...cypherKey],
    name: data.name,
  };
  return user;
};
